<script setup>
import { ref, watch, computed } from 'vue'
import LottiePlayer from './LottiePlayer.vue'
const props = defineProps({
  entry: { type: Object, required: true },
  desktopField: { type: String, default: 'imageDesktop' },
  mobileField: { type: String, default: 'imageMobile' },
  width: { type: Number, default: 866 },
  height: { type: Number, default: 660 },
  active: { type: Boolean, default: true }
})
const size = ref(null)
// Generic media fields can hold video; an old video must not be requested as an <img>.
const imageOf = (value) => {
  const asset = Array.isArray(value) ? value[0] : value
  return /\.(?:avif|gif|jpe?g|png|svg|webp)(?:$|[?#])/i.test(asset?.url || '') ? asset : null
}
const desktopImage = computed(() => imageOf(props.entry[props.desktopField]))
const mobileImage = computed(() => imageOf(props.entry[props.mobileField]))
const ratio = computed(() => size.value ? `${size.value.width} / ${size.value.height}` : `${props.width} / ${props.height}`)
watch(() => props.entry, () => { size.value = null })
</script>
<template>
  <div class="lottie-visual" :style="{ aspectRatio: ratio }">
    <GlobalsImage v-if="desktopImage || mobileImage" :landscape="desktopImage || mobileImage" :portrait="mobileImage || desktopImage" :quality="100" />
    <LottiePlayer :desktop-url="entry.lottieFileDesktop?.[0]?.url || ''" :mobile-url="entry.lottieFileMobile?.[0]?.url || ''" :active="active" fill @loaded="size = $event" />
  </div>
</template>
<style scoped>
.lottie-visual { position: relative; width: 100%; overflow: hidden; border-radius: 16px; }
.lottie-visual :deep(picture), .lottie-visual :deep(img) { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; }
</style>
